export default __webpack_public_path__ + "static/CentraNo2-BookItalic-a9817a49406658f349bdf3f560c24a2a.woff";